module.exports = __webpack_public_path__ + "img/hr-green-asterisk-00.6dac065c.png";